import FeatureSection from "../components/common/sections/FeatureSection";
import CoverSection from "../components/common/sections/CoverSection";
import config from "../config";

const History = ({t}) => {
    const title = t("pages.about_us.submenus.history.title", { returnObjects: true });
    const feature_section_1 = t("pages.about_us.submenus.history.feature_section_1", { returnObjects: true });
    const feature_section_2 = t("pages.about_us.submenus.history.feature_section_2", { returnObjects: true });

    return (
      <div className="content">
        <CoverSection title={title} backgroundImage={config.globalCover}></CoverSection>
        <FeatureSection
          title={feature_section_1.title}
          items={feature_section_1.items}
          image="/images/history/cathedral-murcia.jpg"
          imagePosition='left'
          enableLightbox={true}
        />

        <div className="generic-separator" />

        <FeatureSection
          title={feature_section_2.title}
          items={feature_section_2.items}
          image="/images/history/bolnuevo.jpg"
          imagePosition='right'
          enableLightbox={true}
        />
      </div>
    );
  }

  export default History;